/* eslint semi:0 */
import { mithrilHelpers } from 'utils/mithril'
import BaseVm from 'vms/BaseVm'
import utilsWindow from 'utils/window'

class AdminDropdownVm extends BaseVm {

  constructor(options = {}) {
    super(options)
  }

  get shouldShow() {
    return this.store.isAdmin || this.store.isAuthor
  }

  handleAdminAction(e) {
    e.preventDefault()
    let actionName = e.target.text
    if (confirm(`Really ${actionName} this post ?`)) {
      let responseHandler = this.handleAdminActionResponse.part(actionName)

      mithrilHelpers.safeRequest({
        method: 'POST',
        url: e.target.href,
      }).then(
        responseHandler,
        responseHandler
      )
    }
  }

  handleAdminActionResponse(actionName, response) {
    if (response && response.success) {
      alert(`Successfully ${actionName}`)
      if (response.redirect !== undefined) {
        utilsWindow.redirectTo(response.redirect)
      }
    }
    else {
      alert(`something went wrong while trying to ${actionName}. It might have work and might have not. please try again or verify`)
    }
  }
}

export default AdminDropdownVm


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/vms/adminDropdownVm.js